// contextFieldConfig.ts

import {
  FieldCategoryTypeEnum,
  ITicketTypes,
} from "../../../../TeamSettings/container/Projects/container/WorkItems/types";
import { findFieldGroupByCategory } from "../../../../Boards/helpers";

export const MAX_FIELDS = 8;
export const MAX_PER_COLUMN = 4;

export const DESIGNED_FIELDS = [
  "teamName",
  "projectName",
  "ticketType",
  "status",
  "assignee",
  "dueDate",
  "priority",
  "tags",
];

export const TICKET_DETAILS_FIELDS = [
  "ticketType",
  "status",
  "assignee",
  "dueDate",
  "priority",
  "effortsEstimated",
  "effortsActual",
  "tags",
];

export const getVisibleFields = (
  ticketTypes: ITicketTypes[],
  selectedTypeId: string,
  category: FieldCategoryTypeEnum,
  renderForDetails = false,
) => {
  const designedFields = renderForDetails
    ? TICKET_DETAILS_FIELDS
    : DESIGNED_FIELDS;
  const selectedType = ticketTypes.find((t) => t._id === selectedTypeId);

  return findFieldGroupByCategory(
    selectedType?.ticketTypeFields || [],
    category,
  ).filter((f) => f.isVisible && designedFields.includes(f.fieldToolTip));
};

export const splitColumns = (fields: any[], maxPerColumn: number) => ({
  left: fields.slice(0, maxPerColumn),
  right: fields.slice(maxPerColumn, MAX_FIELDS),
});
